import { render } from "./Navigation.vue?vue&type=template&id=5a5aec1c&lang=pug"
import script from "./Navigation.vue?vue&type=script&lang=js"
export * from "./Navigation.vue?vue&type=script&lang=js"

import "./Navigation.vue?vue&type=style&index=0&id=5a5aec1c&lang=scss"

import exportComponent from "/Applications/DEV/kevin/GIT/monafoto.ee/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__